import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { Moment } from '@shared/app/scripts/vendor/moment';

export type RevisionDetailsFilter = (input: any) => string;

interface IRevisionDetails {
  transform: RevisionDetailsFilter;
}

/**
 * Filter in the coreModule. Creates a human-readable string out of interaction
 * object.
 * @param {any} input TODO document input
 * @return {string} formatted data
 */
@Pipe({ name: 'revisionDetails' })
export class RevisionDetailsPipe implements PipeTransform, IRevisionDetails {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private moment: Moment,
  ) {
    'ngInject';
  }

  public transform(input: any): string {
    const information = [];
    const userNameTranslation = this.$translate.instant('core.user_name');
    const dateTranslation = this.$translate.instant('core.date');
    const actionTranslation = this.$translate.instant('core.action');
    const dateFormat = 'dddd D MMMM YYYY HH:mm:ss';

    // Date when change was made
    if (angular.isObject(input)) {
      if (input.date) {
        information.push(
          `${dateTranslation}: ${this.moment(input.date).format(dateFormat)}`,
        );
      } else {
        information.push(
          `${dateTranslation}: ${this.$translate.instant('core.unknown')}`,
        );
      }

      // User that made the change if known
      if (angular.isObject(input.user)) {
        if (input.user.username) {
          information.push(`${userNameTranslation}: ${input.user.username}`);
        } else {
          information.push(
            `${userNameTranslation}: ${this.$translate.instant(
              'core.unknown',
            )}`,
          );
        }
      } else if (angular.isString(input.user)) {
        information.push(`${userNameTranslation}: ${input.user}`);
      } else {
        information.push(
          `${userNameTranslation}: ${this.$translate.instant('core.unknown')}`,
        );
      }

      // Action - service/endpoint that made the change
      if (angular.isString(input.action)) {
        information.push(`${actionTranslation}: ${input.action}`);
      }

      return information.join('; ');
    }

    return this.$translate.instant('core.unknown');
  }
}
